import { Box, Flex } from '@chakra-ui/react';
import { BrowserView } from 'react-device-detect';
import { MobileViewPage } from '../component/globalComponents/MobileViewPage';
import { Changelog } from '../component/profileComponents/Changelog';

export const DashboardNewsPage = () => {
    const renderContent = () => (
        <Box className={'dashboard-container'}>
            <Flex className={'divider'} />
            <Changelog />
        </Box>
    );

    return (
        <>
            <BrowserView>
                <Box>{renderContent()}</Box>
            </BrowserView>
            <MobileViewPage
                title="NEWS"
                titleColor="#FFF"
                titleBackgroundColor="#6867dd"
                isLoading={false}
            >
                {renderContent()}
            </MobileViewPage>
        </>
    );
};
